import { render, staticRenderFns } from "./ProductArticles.vue?vue&type=template&id=15476b3a&"
import script from "./ProductArticles.vue?vue&type=script&lang=js&"
export * from "./ProductArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports